import Vue from 'vue'
import Router from 'vue-router'
// import Home from './pages/PageHome.vue'
import Upload from './pages/PageUpload.vue'
import NotFound from './pages/PageNotFound.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/upload/:tenantId/:contactIdHash/:certRequirementId',
      name: 'upload',
      component: Upload,
      props: true
    },
    { 
      path: "*", 
      name: 'notFound',
      component: NotFound 
    }
  ]
})
